import React, {  useContext, useEffect, useState} from 'react'
import {Input, Select, DatePicker, TreeSelect, Form,  Checkbox } from 'antd'
import { StateContext } from '../../../state';
import './index.less'
import moment from 'moment';
import http from '../../../../../utils/server'
import Draggable from 'react-draggable';
import sha1 from '../../../../../utils/sha1';
import { Mode } from '../../../../../App';
import {DeviceContext} from './index'
var changeDev = true;

const devTypeorder =[
    {code:201,oId:1},
    {code:212,oId:2},
    {code:209,oId:3},
    {code:203,oId:4},
    {code:208,oId:5},
    {code:205,oId:6},
    {code:210,oId:7},
    {code:211,oId:8},
    {code:206,oId:9},
    {code:207,oId:10},
    {code:202,oId:11},
    {code:204,oId:12},
];

async function  getSimByIccid(iccid,simToken) {
    let r ={
        iccid_expire:'2000-01-01',
        sim:'',
        status: '未找到',
        islock: false
    }
    // await fetch( `http://hebeijiuchen.com/sim/card/all/query.do?queryString=${iccid}`, { //物联网卡查询 接口请求地址
    //     method: 'get',
    //     headers: new Headers({
    //         'Content-Type': 'application/json',
    //         'Authorization': `${simToken}`
    //     })
    // })
    // .then((resp) => {
    //     resp.json().then( res=>{
    //         if (!res.list) return
    //         if(res.list.length==0){//河北卡查询不到
    //             let method = 'fc.function.card.info';
    //             let appKey = 'RL7i4T0Q9024bI7Z';
    //             let t = Math.floor(new Date().getTime()/1000)
    //             let sign = callSign(appKey,method,iccid,t);
    //              fetch(`https://api.quectel.com/openapi/router`,{
    //                 method:'post',
    //                 body:`appKey=${appKey}&iccid=${iccid}&method=${method}&sign=${sign}&t=${t}`,
    //                 headers: {
    //                     'Content-Type': 'application/x-www-form-urlencoded',
    //                 }
    //             }).then(resp=>{
    //                 resp.json().then(res=>{
    //                     if(res.resultCode===0){
    //                         r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
    //                         r.sim = res.msisdn;
    //                         // r.status = res.active;
    //                         r.status = '';
    //                         r.islock = res.islock===1?true:false;
    //                     }else{
    //                         r.iccid_expire='2000-01-01';
    //                         r.sim='';
    //                         r.status = '未找到';
    //                         r.islock = false
    //                     }
    //                 })
    //             })
                
    //         }else{
    //             r.iccid_expire =res.list[0].expireTime!==''?res.list[0].expireTime:'2000-01-01';
    //             r.sim =''+ res.list[0].mobile;
    //             r.status = '';
    //             r.islock = false
    //             let date1 = new Date(res.list[0].expireTime).getTime();
    //             // let date1 = new Date('2023-8-16').getTime();
    //             let date2 = new Date().getTime();
    //             if( date2<date1){
    //                 r.state = 0
    //             }else{
    //                 let days = Math.floor((date2 -date1 )/(24*60*60*1000));
    //                 if(days<20){
    //                     r.state = 1;
    //                 }else{
    //                     r.state = 2;
    //                 }
    //             }
    //         }
    //     })
    // })
    let method = 'fc.function.card.info';
    let appKey = 'RL7i4T0Q9024bI7Z';
    let t = Math.floor(new Date().getTime()/1000)
    let sign = callSign(appKey,method,iccid,t);
    
    const results = await Promise.allSettled([
        (async () => {
            const res = await fetch(`http://hebeijiuchen.com/sim/card/all/query.do?queryString=${iccid}`, { //物联网卡查询 接口请求地址
                method: 'get',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `${simToken}`
                })
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        (async () => {
            const res = await fetch(`https://api.quectel.com/openapi/router`,{
                method:'post',
                body:`appKey=${appKey}&iccid=${iccid}&method=${method}&sign=${sign}&t=${t}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        // (async () => {
        //     const res = await http.get(`/v1/devicesiminfo?numbers=${iccid}`, {})
        //     return res; // 直接 return，等价于 .then() 的效果
        // })(),
    ])

    const validData = results
    .map(res => res.status === 'fulfilled' ? res.value : null)
    if(validData.length>0){
        let res = validData [0];
        if(res&&res.list&&res.list.length>0){
            r.iccid_expire =res.list[0].expireTime!==''?res.list[0].expireTime:'2000-01-01';
            r.sim =''+ res.list[0].mobile;
            r.status = '';
            r.id = 1
            r.islock = false
            let date1 = new Date(res.list[0].expireTime).getTime();
            let date2 = new Date().getTime();
            if( date2<date1){
                r.state = 0
            }else{
                let days = Math.floor((date2 -date1 )/(24*60*60*1000));
                if(days<20){
                    r.state = 1;
                }else{
                    r.state = 2;
                }
            }
        }
        res = validData [1];
        if(res&&res.resultCode===0){
            r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
            r.sim = res.msisdn;
            r.status = '';
            r.id = 2
            r.islock = res.islock===1?true:false;
            if(res.expiryDate!=""){
                let date1 = new Date(res.expiryDate).getTime();
                let date2 = new Date().getTime();
                if( date2<date1){
                    r.state = 0
                }else{
                    r.state = 1
                    // let days = Math.ceil((date2 -date1 )/(24*60*60*1000));
                    // if(days<20){
                    //     r.state = 1;
                    // }
                }
            }
        }
        res = validData [2];
        if(res&&res.code===200&&res.data.length>0){
            r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
            r.sim = res.data[0].msisdn;
            r.iccid = res.data[0].iccid
            r.status = '';
            r.islock = false
            r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
        }
    }else{
        (async () => {
            await http.get(`/v1/devicesiminfo?numbers=${iccid}`, {}).then(res=>{
                if(res.code===200&&res.data.length>0){
                    r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
                    r.sim = res.data[0].msisdn;
                    r.iccid = res.data[0].iccid
                    r.status = '';
                    r.id = 3
                    r.islock = false
                    r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
                }
            })
        })()
    }
    return r
}
async function  getSimBySim(sim,simToken) {
    let r ={
        iccid_expire:'2000-01-01',
        sim:'',
        status: '未找到',
        islock: false
    }
    // fetch( `http://www.hebeijiuchen.com/sim/card/queryCard.do?mobile=${sim}`, { //物联网卡查询 接口请求地址
    //     method: 'get',
    //     headers: new Headers({
    //         'Content-Type': 'application/json',
    //         'Authorization': `${simToken}`
    //     })
    // })
    // .then((resp) => {
    //     resp.json().then(res=>{
    //         r.iccid_expire =res.expireTime!==''?res.expireTime:'2000-01-01';
    //         r.iccid = res.iccid
    //         r.status = '';
    //         r.islock = false
    //         let date1 = new Date(res.expireTime).getTime();
            
    //         let date2 = new Date().getTime();
    //         if( date2<date1){
    //             r.state = 0
    //         }else{
    //             let days = Math.floor((date2 -date1 )/(24*60*60*1000));
    //             if(days<20){
    //                 r.state = 1;
    //             }
    //         }
    //     }).catch((error) => {
    //         let method = 'fc.function.card.info';
    //         let appKey = 'RL7i4T0Q9024bI7Z';
    //         let msisdn = sim;
    //         let t = Math.floor(new Date().getTime()/1000)
    //         let sign = callSign(appKey,method,msisdn,t);
    //         fetch(`https://api.quectel.com/openapi/router`,{
    //             method:'post',
    //             body:`appKey=${appKey}&method=${method}&msisdn=${msisdn}&sign=${sign}&t=${t}`,
    //             headers: {
    //                 'Content-Type': 'application/x-www-form-urlencoded',
    //             }
    //         }).then(resp=>{
    //             resp.json().then(res=>{
    //                 if(res.resultCode===0){
    //                     r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
    //                     r.sim = res.msisdn;
    //                     // r.status = res.active;
    //                     r.status = "";
    //                     r.iccid = res.iccid;
    //                     r.islock = res.islock===1?true:false
    //                     if(res.expiryDate!=""){
    //                         let date1 = new Date(res.expiryDate).getTime();
    //                         let date2 = new Date().getTime();
    //                         if( date2<date1){
    //                             r.state = 0
    //                         }else{
    //                             let days = Math.ceil((date2 -date1 )/(24*60*60*1000));
    //                             console.log('days',days);
    //                             // if(days<20){
    //                             //     r.state = 1;
    //                             // }
    //                         }
                            
    //                     }
    //                 }else{
    //                     r.iccid_expire='2000-01-01';
    //                     r.sim='';
    //                     r.status = '未找到';
    //                     r.islock = false
                        
    //                 }
    //             })
    //         })
    //     })
    // });
    let method = 'fc.function.card.info';
    let appKey = 'RL7i4T0Q9024bI7Z';
    let msisdn = sim;
    let t = Math.floor(new Date().getTime()/1000)
    let sign = callSign(appKey,method,msisdn,t);
    
    const results = await Promise.allSettled([
        (async () => {
            const res = await fetch(`http://hebeijiuchen.com/sim/card/all/query.do?queryString=${sim}`, { //物联网卡查询 接口请求地址
                method: 'get',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `${simToken}`
                })
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        (async () => {
            const res = await fetch(`https://api.quectel.com/openapi/router`,{
                method:'post',
                body:`appKey=${appKey}&method=${method}&msisdn=${msisdn}&sign=${sign}&t=${t}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
            return res.json(); // 直接 return，等价于 .then() 的效果
        })(),
        // (async () => {
        //     const res = await http.get(`/v1/devicesiminfo?numbers=${sim}`, {})
        //     return res; // 直接 return，等价于 .then() 的效果
        // })(),
    ])

    const validData = results
    .map(res => res.status === 'fulfilled' ? res.value : null)
    if(validData.length>0){
        let res = validData [0];
        if(res&&res.list&&res.list.length>0){
            r.iccid_expire =res.list[0].expireTime!==''?res.list[0].expireTime:'2000-01-01';
            r.sim =''+ res.list[0].mobile;
            r.iccid = res.list[0].iccid
            r.status = '';
            r.islock = false
            r.id = 1
            let date1 = new Date(res.list[0].expireTime).getTime();
            let date2 = new Date().getTime();
            if( date2<date1){
                r.state = 0
            }else{
                let days = Math.floor((date2 -date1 )/(24*60*60*1000));
                if(days<20){
                    r.state = 1;
                }else{
                    r.state = 2;
                }
            }
        }
        res = validData [1];
        if(res&&res.resultCode===0){
            r.iccid_expire =res.expiryDate!==''?res.expiryDate:'2000-01-01';
            r.sim = res.msisdn;
            r.iccid = res.iccid
            r.status = '';
            r.id = 2
            r.islock = res.islock===1?true:false;
            if(res.expiryDate!=""){
                let date1 = new Date(res.expiryDate).getTime();
                let date2 = new Date().getTime();
                if( date2<date1){
                    r.state = 0
                }else{
                    r.state = 1
                    // let days = Math.ceil((date2 -date1 )/(24*60*60*1000));
                    // if(days<20){
                    //     r.state = 1;
                    // }
                }
            }
        }
        res = validData [2];
        if(res&&res.code===200&&res.data.length>0){
            r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
            r.sim = res.data[0].msisdn;
            r.iccid = res.data[0].iccid
            r.status = '';
            r.islock = false
            r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
        }
    }else{
            (async () => {
                await http.get(`/v1/devicesiminfo?numbers=${sim}`, {}).then(res=>{
                    if(res.code===200&&res.data.length>0){
                        r.iccid_expire =res.data[0].expiretime!==''?res.data[0].expiretime.slice(0,10) :'2000-01-01';
                        r.sim = res.data[0].msisdn;
                        r.iccid = res.data[0].iccid
                        r.status = '';
                        r.id = 3
                        r.islock = false
                        r.state = res.data[0].state===3?1:res.data[0].state>3?2:0
                    }
                })
            })()
        }
    return r
}

function callSign (appKey,method,s,t){
    let Secret = 'RA9026m2';
    let concat =`${Secret}appKey${appKey}`;
    if(s.length===13){
        let msisdn = s;
        concat +=`method${method}msisdn${msisdn}t${t}${Secret}`;
    }else{
        let iccid = s;
        concat +=`iccid${iccid}method${method}t${t}${Secret}`
    }
    let r = sha1.sha1(concat);
    return r
}
function DeviceFix(props) {
    const { actDevice, dispatchDevice, form, onfinish } = useContext(DeviceContext)
    const { state } = useContext(StateContext)
    const [selectUser, setSelectUser] = useState([])
    const [simToken,setSimToken] = useState('')
    const [simStatus,setSimStatus] = useState('')
    const [simStatus1,setSimStatus1] = useState('')
    const [simChange,setSimChange] = useState(false)
    const [simCompany,setSimCompany] = useState(0)
    const [devTypeOption, setDevTypeOption] = useState([])
    const [isShowUser, setIsShowUser] = useState(false)
    const formRef = React.createRef();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    useEffect(() => {
        setIsShowUser(props?.isShowUser)
        let devTypeOption = []
        state.devicetype.map(m=>{
            let temp = devTypeorder.filter(x=>x.code===m.code);
            m.oId =(temp&&temp.length>0)?temp[0].oId:m.code
            devTypeOption.push(m)
        })
        devTypeOption.sort((a,b)=>a.oId-b.oId)
        setDevTypeOption(devTypeOption)
        let simToken='';
        var p = 1
        const d_d = state.district.filter(x => { return x.id === actDevice.district })
        if (d_d.length > 0) {
            const d_u = state.systemuser.list.filter(x => { return x.id === d_d[0].user })
            if (d_u.length > 0) {
                p = d_u[0].id
                setSelectUser(d_u[0])
            }
        }
        if(Mode==='soc'){
            fetch(' http://www.hebeijiuchen.com/sim/user/login.do?username=17734552912&password=123456', { //物联网卡登录 接口请求地址
            method: 'get',
            }).then((resp) => {
            resp.json().then(async res=>{
                simToken = res.token
                setSimToken(res.token)
                let result
                if(actDevice.sim.length===20){
                    let result1 = await getSimByIccid(actDevice.sim,simToken)
                    form.setFieldsValue({
                        iccid1: result1.sim
                    })
                    setTimeout(() => {
                        if (result1===''){
                            setSimStatus("未能获取到iccid")
                        }else if(result1.status==="未找到"){
                            setSimStatus(result1.status);
                        }else{
                            if(actDevice.sim!==result1.sim){
                                setSimStatus("卡号和ICCID不符")
                            }else if(result1.state===1){
                                setSimStatus("停机")
                            }else if(result1.state===2){
                                setSimStatus("销号")
                            }
                            setSimCompany(result1.id)
                        }
                        form.setFieldsValue({
                            iccid1: result1.sim,
                            iccid_expire_real:moment(result1.iccid_expire, 'YYYY-MM-DD')
                        })
                    }, 1000);
    
                }else{
                    let result1 = await getSimBySim(actDevice.sim,simToken)
                    setTimeout(() => {
                        if (result1===''){
                            setSimStatus("未能获取到iccid")
                        }else if(result1.status==="未找到"){
                            setSimStatus(result1.status);
                        }else{
                            if(result1.state===1){
                                setSimStatus("停机")
                            }else if(result1.state===2){
                                setSimStatus("销号")
                            }else{
                                setSimStatus('')
                            }
                            setSimCompany(result1.id)
                        }
                        
                        form.setFieldsValue({
                            iccid1: result1.iccid,
                            iccid_expire_real:moment(result1.iccid_expire, 'YYYY-MM-DD')
                        })
                    },1000);
                }
                result = ''
                if(actDevice.iccid.length===20){
                    result = await getSimByIccid(actDevice.iccid,simToken);
                }else{
                    
                }
                
                setTimeout(() => {
                    if (result===''){
                        setSimStatus1("未能获取到iccid")
                    }else if(result.status==="未找到"){
                        setSimStatus1(result.status);
                    }else{
                        if(actDevice.sim!==result.sim){
                            setSimStatus1("卡号和ICCID不符")
                        }else if(result.state===1){
                            setSimStatus1("停机")
                        }else if(result.state===2){
                            setSimStatus1("销号")
                        }
                        setSimCompany(result.id)
                    }
                    
                    form.setFieldsValue({
                        iccid_expire_real1:moment(result.iccid_expire, 'YYYY-MM-DD'),
                        simauto:result.sim
                    })
                    // if(actDevice.iccid.length<20){

                    //     form.setFieldsValue({
                    //         iccid:result.iccid
                    //     })
                    // }
                }, 1000);
                
            })
            }).catch((error) => {
                console.log(error);
            });
            if(actDevice.location>1000){
                actDevice.location = actDevice.location-1000
            }
            form.setFieldsValue({
                ...actDevice,
                humi: actDevice.humi === 0 ? false : true,
                door_alarm: actDevice.door_alarm === 0 ? false : true,
                power_alarm: actDevice.power_alarm === 1 ? true : false,
                power_alarm_soc:actDevice.power_alarm > 1 ? true : false,
                hide: actDevice.hide === 1 ? true : false,
                expire: moment(actDevice.expire, 'YYYY-MM-DD 00:00:00'), time: moment(actDevice.time, 'YYYY-MM-DD 00:00:00'), parent: p,
                iccid_expire:  moment(actDevice.iccid_expire, 'YYYY-MM-DD'),cardedittime:moment(actDevice.cardedittime, 'YYYY-MM-DD'),
                simdate:moment(actDevice.simdate, 'YYYY-MM-DD'),cardedittimeauto:moment(actDevice.cardedittimeauto, 'YYYY-MM-DD')
            })
        }else{
            form.setFieldsValue({
                ...actDevice,
                humi: actDevice.humi === 0 ? false : true,
                door_alarm: actDevice.door_alarm === 0 ? false : true,
                power_alarm: actDevice.power_alarm === 0 ? false : true,
                hide: actDevice.hide === 1 ? true : false,
                expire: moment(actDevice.expire, 'YYYY-MM-DD 00:00:00'), time: moment(actDevice.time, 'YYYY-MM-DD 00:00:00'), parent: p,
            })
        }
        
        
    }, [])

    return (
        <Form
            form={form}
            {...formItemLayout}
            ref={formRef}
            onFinish={val=>{
                onfinish(val)
            }}
            >


            {
                Mode === 'soc' && isShowUser&& <Form.Item
                    label="所属用户"
                    name="parent"
                    rules={[
                        {
                            required: true,
                            message: '选择上级用户'
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const u = state.systemuser.list.filter(x => { return x.id === value })
                                if (u.length > 0 && u[0].type !== 104) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('普通用户不可选'));
                            },
                        }),
                    ]}>
                    <TreeSelect
                        showSearch
                        treeNodeFilterProp='name'
                        treeDefaultExpandAll
                        treeData={state.systemuser.treeM}
                        placeholder="上级用户"
                        onChange={value => {
                            const u = state.systemuser.list.filter(x => { return x.id === value })
                            if (u.length > 0 && u[0].type !== 104) {
                                setSelectUser(u[0])
                            }
                            formRef.current.setFieldsValue({
                                district:""
                            })
                        }}
                        
                    />
                </Form.Item>
            }
            {
                (isShowUser||Mode !== 'soc')&&
                <Form.Item label="所属区域"
                    name="district"
                    rules={[{ required: true, message: '选择所属区域' }]}>
                    <Select
                        placeholder="选择区域"
                    >
                        {
                            Mode !== 'soc' ? state.district.map(item => (
                                <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                            )) :
                                state.district.filter(x => { return x.user === selectUser.id }).map(item => (
                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                ))
                        }
                    </Select>
                </Form.Item>

            }
            
            <div style={{ display: 'flex' }}>
                <Form.Item label="主机类型"
                    labelCol={{ span: 8 }}
                    style={{ width: 300 }}
                    name="type"
                    rules={[{ required: true, message: '选择主机类型' }]}>
                    <Select
                        placeholder="主机类型"
                        // location 0:GPS  1:基站 2:无 
                        onChange={value => {
                            switch (value) {
                                case 201: formRef.current.setFieldsValue({
                                    location: 2, humi: true
                                }); return;
                                case 202: formRef.current.setFieldsValue({
                                    location: 1, humi: false
                                }); return;
                                case 203: formRef.current.setFieldsValue({
                                    location: 0, humi: false
                                }); return;
                                case 204: formRef.current.setFieldsValue({
                                    location: 2, humi: true
                                }); return;
                                case 205: formRef.current.setFieldsValue({
                                    location: 2, humi: false
                                });  
                                case 207: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:true
                                }); return;
                                case 208: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:true
                                }); return;
                                case 209: formRef.current.setFieldsValue({
                                    location: 1, humi: false,power_alarm:false
                                }); return;
                                case 213: formRef.current.setFieldsValue({
                                    location: 2, humi: false,power_alarm:false
                                });
                                case 215: formRef.current.setFieldsValue({
                                    location: 2, humi: true,power_alarm:false,
                                }); 
                                return;
                            }
                        }}
                    >
                        {
                            devTypeOption.map(item => (
                                // item.code!==204&&
                                <Select.Option key={item.code} value={item.code}>{item.value}</Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="主机编号"
                    labelCol={{ span: 8 }}
                    style={{ width: 300 }}
                    name="sn"
                    rules={[{ required: true, message: '输入主机编号' }]}>
                    <Input disabled={changeDev} />
                </Form.Item>
            </div>
            {
                Mode === "local" ?
                    <div style={{ display: 'flex' }}>
                        <Form.Item style={{ width: 400 }}
                            labelCol={{ span: 6 }}
                            label="主机名称"
                            name="m_name"
                            rules={[{ required: true, message: '输入主机名称' }]}>
                            <Input  />
                        </Form.Item>
                        <Form.Item style={{ width: 200 }}
                            labelCol={{ span: 12 }}
                            label="平台设备"
                            name="status"
                            valuePropName="checked"
                        >
                            <Checkbox>选择</Checkbox>
                        </Form.Item>
                    </div> :
                    <Form.Item
                        label="主机名称"
                        name="m_name"
                        rules={[{ required: true, message: '输入主机名称' }]}>
                        <Input  />
                    </Form.Item>
            }
            <div style={{ display: 'flex' }}>
                <Form.Item label="测点名称"
                    labelCol={{ span: 6 }}
                    style={{ width: 400 }}
                    name="name"
                    rules={[{ required: true, message: '输入测点名称' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="测点ID"
                    labelCol={{ span: 10 }}
                    style={{ width: 200 }}
                    name="node"
                    rules={[{ required: true, message: '输入测点ID' }]}>
                    <Input disabled={changeDev}/>
                </Form.Item>
            </div>
            <div style={{ display: actDevice.node===0 ||[209,214].includes(actDevice.type)?'flex':'none'}}>
                <div style={{ display: actDevice.node===0 ?'flex':'none'}}>
                    <Form.Item label="断电"
                        labelCol={{ span: 10 }}
                        style={{ width: 104 }}
                        name="power_alarm"
                        valuePropName="checked"
                    >
                        <Checkbox disabled={actDevice.node!==0} onChange={e=>{
                            if(e.target.checked){
                                formRef.current.setFieldsValue({
                                    power_alarm_soc:false
                                })
                            }else{
                                if(!formRef.current.getFieldValue("door_alarm")){
                                    formRef.current.setFieldsValue({
                                        power_alarm:true
                                    })
                                }
                            }
                        }}>
                            设备
                        </Checkbox>
                    </Form.Item>
                    <span style={{fontSize:20}}>/</span>
                    <Form.Item
                        labelCol={{ span: 10 }}
                        style={{ width: 104 ,marginLeft:8}}
                        name="power_alarm_soc"
                        valuePropName="checked"
                    >
                        <Checkbox disabled={actDevice.node!==0} onChange={e=>{
                            if(e.target.checked){
                                formRef.current.setFieldsValue({
                                    power_alarm:false
                                })
                            }else{
                                if(!formRef.current.getFieldValue("door_alarm")){
                                    formRef.current.setFieldsValue({
                                        power_alarm_soc:true
                                    })
                                }
                            }
                        }}>
                            平台
                        </Checkbox>

                    </Form.Item>
                </div>
                
                <Form.Item label="开关门"
                    labelCol={{ span: 8 }}
                    style={{ width: 150 }}
                    name="door_alarm"
                    valuePropName="checked"
                >
                    <Checkbox disabled={([209,214].includes(actDevice.type) && actDevice.node===0 )} onChange={e=>{
                        if(!formRef.current.getFieldValue("power_alarm")&&!formRef.current.getFieldValue("power_alarm_soc")){
                            formRef.current.setFieldsValue({
                                door_alarm:e.target.checked
                            })
                        }
                    }} >
                        开启
                    </Checkbox>
                </Form.Item>
            </div>
            <div style={{ display: actDevice.node===0 &&'none'}}>
                <div style={{ display: 'flex' }}>
                    <Form.Item label="定位方式"
                        labelCol={{ span: 7 }}
                        style={{ width: 300 }}
                        name="location"
                        rules={[{ required: true, message: '选择定位方式' }]}>
                        <Select
                            placeholder="定位方式"
                        >
                            {
                                [{ id: 0, name: '卫星定位' }, { id: 1, name: 'LBS定位' }, { id: 2, name: '无定位' }, { id: 3, name: 'LBS定位2' }].map(item => (
                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    {
                        Mode === "soc"&&state.main.type<103&&
                        <div style={{width:230}}>
                            <Form.Item 
                                labelCol={{ span: 10}}
                                label="卡到期时间"
                                name="iccid_expire"
                            >
                                <DatePicker format={"YYYY-MM-DD"} style={{width:130}} disabled={state.main.type>100}/>
                            </Form.Item>
                        </div> 
                    }
                </div>
                {
                    Mode === "soc"&&state.main.type<101&&
                    <div style={{color:'red',display:'flex',justifyContent:'space-between'}}>
                        <span>卡属：{simCompany}</span>
                        <span>自动读卡：{simStatus1}</span>
                        <span>填写卡：{simStatus}</span>
                        {/* <div>
                            
                            <span style={{color:'red'}}>{simStatus}</span>
                        </div> */}
                    </div>
                }
                {/* sim卡号和编辑时间 */}
                <div style={{ display: 'flex' }}>
                    <Form.Item style={{ width: 300 }}
                        labelCol={{ span: 7 }}
                        label="SIM卡号"
                        name="sim"
                        rules={[{ required: true, message: '输入SIM卡号' }]}>
                        <Input controls={false}  style={{width:140}} onChange=
                        {async e=>
                            {
                                let val = e.target.value;
                                if(val.length===13){
                                    let r = await getSimBySim(val,simToken);
                                    setTimeout( () => {
                                        setSimStatus(r.status);
                                        setSimCompany(r.id)
                                        form.setFieldsValue({
                                            iccid_expire_real:moment(r.iccid_expire, 'YYYY-MM-DD'),
                                            iccid1:r.iccid,
                                            cardedittime:moment(new Date(), 'YYYY-MM-DD'),
                                        })
                                    }, 1000);
                                    
                                }else if(val.length===20){
                                    // setSimStatus('卡号错误');
                                    let r =await getSimByIccid(val,simToken);
                                        setTimeout(() => {
                                            setSimStatus(r.status);
                                            setSimCompany(r.id)
                                            if(r.state===1){
                                                setSimStatus("停机")
                                            }else if(r.state===2){
                                                setSimStatus("销号")
                                            }
                                            form.setFieldsValue({
                                                iccid_expire_real:moment(r.iccid_expire, 'YYYY-MM-DD'),
                                                iccid1:r.sim,
                                                cardedittime:moment(new Date(), 'YYYY-MM-DD'),
                                            })
                                        }, 1000);
                                }
                                // setSimChange(true)
                            }
                        }/>
                    </Form.Item>
                    {
                        Mode==='soc'&&
                        <Form.Item  
                            labelCol={{ span: 8 }}
                            label="编辑日期"
                            name="cardedittime"
                        >
                            <DatePicker format={"YYYY-MM-DD"} style={{width:130}} disabled />
                        </Form.Item>
                    }
                    
                </div>
                {/* 卡iccid和到期时间 */}
                <div style={{ display:  Mode==='soc'?'flex':'none' }}>
                    <div style={{width:260}}>
                        <Form.Item 
                            labelCol={{ span: 6 }}
                            label="SIMid"
                            // name={state.main.type<101?"iccid1":'iccid'}
                            name={"iccid1"}
                        >
                            <Input controls={false} style={{width:185}} disabled/>
                        </Form.Item>
                    </div>
                    {
                        Mode === "soc"&&state.main.type<101&&
                        <div style={{width:230}}>
                            <Form.Item 
                                labelCol={{ span: 10}}
                                label="到期时间"
                                name="iccid_expire_real"
                            >
                                <DatePicker format={"YYYY-MM-DD"} style={{width:130} } disabled/>
                            </Form.Item>
                        </div>
                    }
                    {
                        Mode === "soc"&& state.main.type >100 &&
                        <div style={{color:'red'}}>
                            {
                                simStatus
                            }
                        </div>
                    }
                </div>
                
                {/* 自动读取sim卡号和编辑时间 */}
                <div style={{ display:  Mode==='soc'?'flex':'none' }}>
                    {
                        // Mode === "soc"&&state.main.type<101&&
                        Mode === "soc"&&
                        <Form.Item style={{ width: 300 }}
                            labelCol={{ span: 8 }}
                            label="SIM卡号"
                            name="simauto"
                        >
                            <Input controls={false} disabled style={{width:140}} />
                        </Form.Item>
                    }
                    {
                        // Mode === "soc"&&state.main.type<101&&
                        Mode === "soc"&&
                        <Form.Item  
                            labelCol={{ span: 8 }}
                            label="编辑日期"
                            name="cardedittimeauto"
                        >
                            <DatePicker format={"YYYY-MM-DD"} style={{width:130}} disabled />
                        </Form.Item>
                    }
                </div> 
                {/* 自动读取卡iccid和到期时间 */}
                <div style={{ display:  Mode==='soc'?'flex':'none' }}>
                    {
                        // Mode === "soc"&&state.main.type<101&&
                        Mode === "soc"&&
                        <div style={{width:260}}>
                            <Form.Item 
                                labelCol={{ span: 6 }}
                                label="SIMid"
                                name="iccid"
                            >
                                <Input controls={false} disabled  style={{width:185}} />
                            </Form.Item>
                        </div>
                    }
                    
                    {
                        Mode === "soc"&&state.main.type<101&&
                        <div style={{width:230}}>
                            <Form.Item 
                                labelCol={{ span: 10}}
                                label="到期时间"
                                name="iccid_expire_real1"
                            >
                                <DatePicker format={"YYYY-MM-DD"} style={{width:130} } disabled/>
                            </Form.Item>
                        </div>
                        
                    }
                </div>
                <div style={{ display: 'none' ,marginLeft:10}}>
                    <Form.Item label="温度上限"
                        labelCol={{ span: 14}}
                        style={{width:150}} 
                        name="temp_alarm_high"
                        rules={[{ required: true, message: '输入温度上限' }]}>
                        <input  style={{ width: 50 }}/>
                    </Form.Item>
                    <Form.Item label="温度下限"
                        labelCol={{ span: 14 }}
                        style={{width:150}}
                        name="temp_alarm_low"
                        rules={[{ required: true, message: '输入温度下限' }]}>
                        <Input  style={{ width: 50 }}/>
                    </Form.Item>
                    <Form.Item label="湿度上限"
                        labelCol={{ span: 14 }}
                        style={{width:150}}
                        name="humi_alarm_high"
                        rules={[{ required: true, message: '输入湿度上限' }]}>
                        <input  style={{ width: 50 }}/>
                    </Form.Item>
                    <Form.Item label="湿度下限"
                        labelCol={{ span: 14 }}
                        style={{width:150}}
                        name="humi_alarm_low"
                        rules={[{ required: true, message: '输入湿度下限' }]}>
                        <Input  style={{ width: 50 }}/>
                    </Form.Item>
                </div>
                <div style={{ display: 'flex' }}>
                    <Form.Item label="测点隐藏"
                        labelCol={{ span: 8 }}
                        style={{ width: 300 }}
                        name="hide"
                        valuePropName="checked"
                    >
                        <Checkbox style={{ width: 80 }}>隐藏</Checkbox>
                    </Form.Item>
                    {
                        (state.main.type < 103) &&
                        <Form.Item label="安装时间"
                            labelCol={{ span: 8 }}
                            style={{ width: 300 }}
                            name="time"
                            rules={[{ required: true, message: '选择安装时间' }]}>
                            <DatePicker format={"YYYY-MM-DD 00:00:00"} disabled={state.main?.type >100}/>
                        </Form.Item>
                    }
                </div>
                
            </div>
            <div style={{ display: 'flex' }}>
                <div style={{ display: actDevice.node===0 &&'none'}}>
                    <Form.Item label="湿度数据"
                        labelCol={{ span: 8 }}
                        style={{ width: 300 }}
                        name="humi"
                        valuePropName="checked"
                    >
                        <Checkbox>开启</Checkbox>
                    </Form.Item>

                </div>
                    
                    {
                        (state.main.type < 103)  && Mode==='soc'&&
                        <Form.Item label="到期时间"
                            labelCol={{ span: 8 }}
                            style={{ width: 300 }}
                            name="expire"
                            rules={[{ required: true, message: '选择到期时间' }]}>
                            <DatePicker format={"YYYY-MM-DD 00:00:00"} disabled={state.main?.type >101}/>
                        </Form.Item>
                    }
                </div>
            
        </Form>
    )
}
export default DeviceFix